import { getBrowserSupabaseClient } from "@west-tennessee-consulting/supabase";

/**
 * Creates a standard Supabase client for browser use
 * 
 * This client is automatically protected by the global auth guard.
 * All API calls are blocked until authentication is complete.
 */
export function createClient() {
  return getBrowserSupabaseClient();
}
